import * as React from "react";
import { Col, Row, Progress } from "antd";
import styled from "styled-components";
import { OrderStatus, hasStatusReachedStatus } from "../../../lib/model/OrderStatus";

type StatusLabelProps = {
    isActive: boolean;
};

const StatusLabel = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: ${(props: StatusLabelProps) => props.isActive ? "#386ee8" : "#061a32"};
`;

const progressPercentForStatus = (status: OrderStatus): number => {
  // reverse order because of early exit
  if (hasStatusReachedStatus(status, OrderStatus.ReadyToInvoice)) return 100
  if (hasStatusReachedStatus(status, OrderStatus.InProgress)) return 77
  return 26
}

type Props = {
  status: OrderStatus;
};

export const OrderProgressIndicator: React.FC<Props> = props => {
  const { status } = props;
  return (
    <>
      <Row type="flex" justify="space-between">
        <Col>
          <StatusLabel isActive={hasStatusReachedStatus(status, OrderStatus.Booked)}>Auftrag erstellt</StatusLabel>
        </Col>
        <Col>
          <StatusLabel isActive={hasStatusReachedStatus(status, OrderStatus.InProgress)}>Tourstart</StatusLabel>
        </Col>
        <Col>
          <StatusLabel isActive={hasStatusReachedStatus(status, OrderStatus.InProgress)}>Durchführung</StatusLabel>
        </Col>
        <Col>
          <StatusLabel isActive={hasStatusReachedStatus(status, OrderStatus.ReadyToInvoice)}>Tourende</StatusLabel>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <Progress percent={progressPercentForStatus(status)} showInfo={false} strokeColor="#386ee8"/>
        </Col>
      </Row>
    </>
  );
};
